import { FieldType } from '@interfaces/global/config-global';
import I18n from '@src/i18n';
import { Button, Checkbox, DatePicker, Form, Input, InputNumber, Radio, Select } from 'antd';
import moment from 'moment';
import React from 'react';
import MaskedInput from 'react-text-mask';
import verifyItemPermission from '@src/helpers/verifyItemPermission';

type PropType = {
	data?: any,
	extraFields?: any,
	onCancel: Function,
	onSubmit: Function,
	listGroups?: any;
	form: any,
	shouldFilterGroup?: boolean
}

type StateType = {}

export default class UsersFormComponent extends React.Component<PropType, StateType> {

	constructor (props: PropType) {
		super(props)
		this.state = {}
	}

	getOptionalLabel = (label: string) => {
		return (
			<span>
				<span>{label}</span>
				<span className={"goepik-small-left-margin goepik-text-gray"} style={{ fontWeight: 'normal' }}>({I18n.l('common.optional')})</span>
			</span>
		)
	}

	handleSubmit = async (e: any) => {
		e.preventDefault();
		this.props.form.validateFields((err: any, values: any) => {
			if (!err) {
				this.props.onSubmit(values);
			} else {
				console.log('Form submit Errors', err)
			}
		});
	}

	getGroups() {
		const { listGroups, data, shouldFilterGroup } = this.props

		let options: JSX.Element[] = []
		for (let group of listGroups) {
			const isDisabled = shouldFilterGroup ? !verifyItemPermission([`${group.id}`], 'can_create_users', group['created_by']) : false
			options.push(
				<Checkbox disabled={isDisabled} key={group.id} value={`${group.id}`} style={{ marginLeft: '5px' }}>{group.name}</Checkbox>
			)
		}
		return options;
	}

	render() {
		const { data, extraFields, onCancel } = this.props
		const { getFieldDecorator } = this.props.form

		// Extrafields form

		let extraFieldsInput: JSX.Element[] = [];
		extraFieldsInput = extraFields.map((item: any) => {

			const type = String(FieldType[item.type]).toLowerCase();

			switch (type) {
				case 'boolean':
					const RadioGroup = Radio.Group;
					const selectedVal = data[item.id] || "";
					let selectedRadio;
					if (selectedVal === I18n.l('common.yes'))
						selectedRadio = 'yes';
					else if (selectedVal === I18n.l('common.no'))
						selectedRadio = 'no';
					return (
						<Form.Item key={`${item.id}-${item.name}`}
							label={item.name}
							colon={false}
						>
							{getFieldDecorator(`${item.id}`, {
								initialValue: `${selectedRadio}`
							}
							)(
								<RadioGroup>
									<Radio value={'yes'}>{I18n.l('common.yes')}</Radio>
									<Radio value={'no'}>{I18n.l('common.no')}</Radio>
								</RadioGroup>
							)
							}
						</Form.Item>
					)
				case 'date':
					const dateValue = data[item.id] ? moment(data[item.id]) : undefined;
					return (
						<Form.Item key={`${item.id}-${item.name}`}
							label={item.name}
							colon={false}
						>
							{getFieldDecorator(`${item.id}`, {
							}
							)(
								<DatePicker placeholder="dd/mm/aaaa" showToday={false} format={I18n.l('common.dateFormat')} defaultValue={dateValue} />
							)
							}
						</Form.Item>
					)

				case 'number':
					return (
						<Form.Item key={`${item.id}-${item.name}`}
							label={item.name}
							colon={false}
						>
							{getFieldDecorator(`${item.id}`, {
								initialValue: `${data[item.id] || ""}`
							}
							)(
								<InputNumber />
							)
							}
						</Form.Item>
					)
				case 'list':
					const Option = Select.Option;
					const selectValue = item.value.map((value: any, i: any) => (
						<Option value={value} key={i}>{value}</Option>
					));
					const selectedValue = data[item.id] || "";
					return (
						<Form.Item key={`${item.id}-${item.name}`}
							label={item.name}
							colon={false}
						>
							{getFieldDecorator(`${item.id}`, {
								initialValue: `${selectedValue}`
							}
							)(
								<Select>
									<Option value=""></Option>
									{selectValue}
								</Select>
							)
							}
						</Form.Item>
					)
				default:
					return (
						<Form.Item key={`${item.id}-${item.name}`}
							label={item.name}
							colon={false}
						>
							{getFieldDecorator(`${item.id}`, {
								initialValue: `${data[item.id] || ""}`
							}
							)(
								<Input />
							)
							}
						</Form.Item>
					)
			}
		})

		const getGroups = this.getGroups()
		
		return (
			<div>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item key="name"
						label={I18n.l('form.labels.name')}
						colon={false}
					>
						{getFieldDecorator(`name`, {
							rules: [
								{ required: true, message: I18n.l("api.REQUIRED") },
								{
									min: 3, message: I18n.l("api.MINLENGTH")
								},
								{
									max: 50, message: I18n.l("api.MAXLENGTH")
								},
							],
							initialValue: data.name || ''
							// initialValue: _.get(_.find(this.state.formEditItem, item => item.name === 'name'), 'value') || ''
						}
						)(
							<Input />
						)
						}
					</Form.Item>
					<Form.Item key="username"
						label={I18n.l('form.labels.username')}
						colon={false}
					>
						{getFieldDecorator(`username`, {
							rules: [
								{
									required: true,
									message: I18n.l("api.REQUIRED")
								},
								{
									pattern: /^[a-zA-Z0-9.-_]*$/,
									message: I18n.l("api.DISTRIBUTOR_CODE_INVALID")
								},
								{
									min: 3, message: I18n.l("api.MINLENGTH")
								},
								{
									max: 50, message: I18n.l("api.MAXLENGTH")
								},
							],
							initialValue: data.username || ''
						}
						)(
							<Input disabled={data.id ? true : false} />
						)
						}
					</Form.Item>
					<Form.Item key="email"
						label={I18n.l('form.labels.email')}
						colon={false}
					>
						{getFieldDecorator(`email`, {
							rules: [
								{
									type: 'email',
									message: I18n.l("api.EMAIL")
								},
								{
									required: true,
									message: I18n.l("api.REQUIRED")
								}
							],
							initialValue: data.email || ''
						}
						)(
							<Input />
						)
						}
					</Form.Item>
					<Form.Item key="phone"
						label={I18n.l('form.labels.phone')}
						colon={false}
					>
						{getFieldDecorator(`phone`, {
							initialValue: data.phone || '',
						}
						)(
							<MaskedInput
								mask={['+', /[1-9]/, /\d/, ' ', '(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,]}
								name="phone"

								guide={false}
								className="ant-input" />
						)
						}
					</Form.Item>

					{getGroups.length > 0 && <Form.Item key="group"
					label={I18n.l('permissions.group')}
					colon={false}
					>
						{getFieldDecorator(`group`, {
							initialValue: data.group || ''
						}
						)(
							<Checkbox.Group>
								{getGroups}
							</Checkbox.Group>
						)
						}
					</Form.Item>}
					{getFieldDecorator(`id`, {
						initialValue: data.id || '',
					}
					)(
						<Input type="hidden" />
					)
					}
					{extraFieldsInput}
					<Form.Item style={{ textAlign: 'right' }}>
						<Button
							style={{ marginRight: 8 }}
							className="link primary bolder"
							size="large"
							onClick={(e: any) => {
								e.preventDefault();
								if (e.detail !== 0) {
									onCancel();
								}
							}}>
							{I18n.l('common.cancel')}
						</Button>
						<Button type="primary" htmlType="submit" size="large">{I18n.l('common.save')}</Button>
					</Form.Item>
				</Form>
			</div>
		)
	}

}

export const UsersForm = Form.create()(UsersFormComponent);
